export default __webpack_public_path__ + "static/media/Barasingha.c8086a92.jpg";